import React, { useEffect, useState } from 'react';
import moment from 'moment';

import AdminSearch from '../components/AdminSearch';
import Header from '../components/Header';
import ActivityTable from '../components/ActivityTable';

const AdminActivity = ({ user, onLogout }) => {
  const [loading, setLoading] = useState(false);
  const [dataError, setDataError] = useState('');
  const [results, setResults] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);

  const [memberships, setMemberships] = useState(0);
  const [yearUsers, setYearUsers] = useState(0);
  const [qrAccess, setQRAccess] = useState(0);
  const [btAccess, setBTAccess] = useState(0);
  const [codeAccess, setCodeAccess] = useState(0);

  useEffect(() => {
    getMemberships();
    getWashes();
    setLoading(false);
  }, [])

  useEffect(() => {
    setFilteredResults(results)
  }, [results])

  const getMemberships = () => {
    setLoading(true);

    fetch("/api/vehicles")
      .then(res => res.json())
      .then(
        (result) => {
          setMemberships(result.length)
        },
        (error) => {
          console.log(error)
        }
    )
  }

  const getWashes = () => {
    setLoading(true);

    fetch("/api/washes")
      .then(res => res.json())
      .then(
        (result) => {
          mapResults(result)
        },
        (error) => {
          console.log(error)
        }
    )
  }

  const onSearchUsers = (startDate, endDate) => {
    // won't use vehicle or onlyActive
    if (!loading) {
      setLoading(true);
      setDataError('');

      // let url = new URL(`${window.location.href.replace('/admin/activity', '')}/api/washes/search`);
      // url.search = new URLSearchParams({
      //   startDate: startDate && startDate !== '' ? moment(startDate).startOf('day').subtract(1, 'days') : 'none',
      //   endDate: endDate && endDate !== '' ? moment(endDate).endOf('day') : 'none'
      // })

      // fetch(url)
      //   .then(res => res.json())
      //   .then(
      //     (result) => {
      //       mapResults(result)
      //       setLoading(false)
      //     },
      //     (error) => {
      //       console.log(error)
      //       setDataError('There was a problem loading data.')
      //       setLoading(false)
      //     }
      // )

      setFilteredResults(results.filter(r => (!startDate || moment(startDate).isSameOrBefore(moment(r.washDate))) && (!endDate || moment(endDate).isSameOrAfter(moment(r.washDate)))))
      setLoading(false)
    }
  }

  const mapResults = (result) => {
    const mappedResults = result.map(r => {
      return {
        memberNumber: r.vehicle.memberNumber,
        status: !r.vehicle || !r.vehicle.subscription ? 'Unassigned' : moment().startOf('day').isSameOrAfter(moment(r.vehicle.subscription.expirationDate).endOf('day')) ? 'Expired' : 'Active',
        plan: r.vehicle && r.vehicle.subscription && r.vehicle.subscription.subscriptionTier ? r.vehicle.subscription.subscriptionTier.name : 'N/A',
        approved: r.status,
        washDate: moment(r.createdAt).format('MM/DD/YYYY'),
        memberName: `${r.vehicle.user.prefix} ${r.vehicle.user.lastName}`,
        access: r.access,
        email: r.vehicle.user.email
      }
    })
    
    setResults(mappedResults.sort((a,b) => (moment(a.washDate).isAfter(moment(b.washDate))) ? 1 : ((moment(b.washDate).isAfter(moment(a.washDate))) ? -1 : 0)))

    if (yearUsers === 0) {
      // only set once for this current year's uses
      const thisYear = moment().format('YYYY')
      const yearResults = mappedResults.filter(r => r.washDate.includes(thisYear));
      setYearUsers(yearResults.length);
    }

    const qrAccess = mappedResults.filter(r => r.access === 'qr');
    setQRAccess(qrAccess.length);
    const btAccess = mappedResults.filter(r => r.access === 'bt');
    setBTAccess(btAccess.length);
    const codeAccess = mappedResults.filter(r => r.access === 'code');
    setCodeAccess(codeAccess.length);
  }

  return (
    <div>
      <Header user={user} onLogout={onLogout}></Header>
      <AdminSearch searchUsers={onSearchUsers} members={memberships} yearWashes={yearUsers} qr={qrAccess} bt={btAccess} code={codeAccess}></AdminSearch>
      <ActivityTable activities={filteredResults} loading={loading} dataError={dataError}></ActivityTable>
    </div>
  )
}

export default AdminActivity;